<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.currentTreatments') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mTreatment.intitule }}
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.description') }}:

                                        <span class="font-weight-bold" v-html="mTreatment.description">
                                            <!-- {{ mTreatment.description }} -->
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center">
                                <div class="card-footer text-right" v-if="mTreatment.isAuthor || hasAdminRole || hasMedecinControleRole">
                                    <b-button variant="primary" @click="updateTreatment">
                                        {{ $t('message.edit') }}
                                    </b-button>

                                    <b-button v-b-modal.delete-modal variant="danger">
                                        {{ $t('message.delete') }}
                                    </b-button>
                                </div>

                                <b-modal
                                        id="delete-modal"
                                        size="sm"
                                        header-bg-variant="danger"
                                        header-text-variant="light"
                                        :title="$t('message.delete') + ' ' + $t('message.currentTreatments')"
                                        hide-footer
                                >
                                    <div class="d-block text-center">
                                        <h3>{{ $t('message.delete') }} {{ mTreatment.description }}?</h3>
                                    </div>

                                    <div class="d-block float-right">
                                        <b-button variant="danger" @click="deleteTreatment">
                                            {{ $t('message.delete') }}
                                        </b-button>

                                        <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                            {{ $t('message.cancel') }}
                                        </b-button>
                                    </div>
                                </b-modal>
                            </b-row>
                        </div>

                    </b-container>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Treatment",

        computed: {
            ...mapGetters(["traitement",'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole',
            ]),
            can: function (){
                if (this.hasAdminRole || this.hasMedecinControleRole){
                    return true;
                }else{
                    return this.hasPraticienRole;
                }
            },
            mTreatment: function() {
                return this.traitement;
            }
        },

        data() {
            return {
                treatment_id: this.$route.params.treatment
            }
        },

        methods: {
            getTreatment: function() {
                let args = {
                    treatment: this.treatment_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getTraitement', { args, errorMessages });
            },

            updateTreatment() {
                this.$router.push({ name: 'edit-current-treatment', params: { treatment: this.treatment_id } });
            },

            deleteTreatment() {
                let self = this;
                let args = {
                    treatment: this.treatment_id
                };

                let successMessage = this.$i18n.t('message.currentTreatmentsDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteActuelTraitement', { args, index: self.treatment_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getTreatment();
        }
    }
</script>

<style scoped>

</style>